import { inject } from 'vue'

export const LIST_TABLE_HEIGHT_KEY = Symbol('listTableHeight')

/** 在 TableListShell 的 #table 插槽内使用，作为 el-table 的 height（填满中间区域，内部滚动） */
export function useListTableHeight() {
  return inject(LIST_TABLE_HEIGHT_KEY, undefined)
}
